import { useFormContext } from "react-hook-form";
import { t } from "@/i18n-js/instance";
import { classNames } from "@/react/helpers/twMergeWithCN";
import { Button } from "@circle-react-uikit/Button";
import { Typography } from "@circle-react-uikit/Typography";
import { COURSES_DIRECTORY_FORM_ID } from "./index";

interface ModalFooterProps {
  isUpdating: boolean;
  onCancel: () => void;
}

export const ModalFooter = ({ isUpdating, onCancel }: ModalFooterProps) => {
  const {
    formState: { isDirty },
  } = useFormContext();
  return (
    <div
      className={classNames("flex w-full flex-col items-center md:flex-row", {
        "justify-end": !isDirty,
        "justify-between": isDirty,
      })}
    >
      {isDirty && (
        <div className="mb-4 self-start md:mb-0 md:self-center">
          <Typography.LabelSm weight="semibold">
            {t("unsaved_changes")}
          </Typography.LabelSm>
        </div>
      )}
      <div className="flex gap-4 self-end md:self-center">
        <Button type="submit" variant="secondary" onClick={onCancel}>
          {t("cancel")}
        </Button>
        <Button type="submit" variant="circle" form={COURSES_DIRECTORY_FORM_ID}>
          {isUpdating ? t("saving_changes") : t("save_changes")}
        </Button>
      </div>
    </div>
  );
};
